export const CERTIFICATE_STATUS = {
  0: { label: "None", className: "bg-slate-50 text-slate-600" },
  1: { label: "Draft", className: "bg-amber-50 text-amber-700" },
  2: { label: "Issued", className: "bg-emerald-50 text-emerald-700" },
  3: { label: "Reissued", className: "bg-blue-50 text-blue-700" },
  4: { label: "Revoked", className: "bg-red-50 text-red-700" },
  5: { label: "Expired", className: "bg-slate-100 text-slate-600" },
};
export const getCertificateStatus = (id) => CERTIFICATE_STATUS[Number(id)] || CERTIFICATE_STATUS[0];
